import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_WiggleForm = _resolveComponent("WiggleForm")!
  const _component_UserDetailForm = _resolveComponent("UserDetailForm")!
  const _component_UserUsageForm = _resolveComponent("UserUsageForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Wiggle View",
      subtitle: "Hello there wiggler. Enter the endpoint and email before requesting changes."
    }),
    _createElementVNode("main", null, [
      _createVNode(_component_WiggleForm, { header: _ctx.header }, null, 8, ["header"]),
      _createElementVNode("p", null, [
        _createVNode(_component_UserDetailForm, { header: _ctx.header }, null, 8, ["header"])
      ]),
      _createElementVNode("p", null, [
        _createVNode(_component_UserUsageForm, { header: _ctx.header }, null, 8, ["header"])
      ])
    ])
  ]))
}